// Dangerous to use this function,
// we need to make sure that user created
// content is safe from XSS
export const clearStringFromHtmlTags = (str?: string) => {
  if (!str) return str;
  const temp = document.createElement('div');
  temp.innerHTML = str;
  return temp.textContent || undefined;
};
